import GameStateStore from 'app/src/game/GameStateStore';
import { createContext, useContext } from 'react';

type GameStateContext = {
	gameStateStore: GameStateStore;
	attempt: number;
	resets: number;
	executingProgram: boolean;
	start: () => void;
	reset: () => void;
};

const context = createContext<GameStateContext | null>(null);

export function useGameStateContext(): GameStateContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('useGameStateContext must be used within a GameStateContextProvider');
	}

	return contextValue;
}

export const GameStateContextConsumer = context.Consumer;
export const GameStateContextProvider = context.Provider;
